import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    busqueda: false,
    permisos: {},
    usuario: {},
    perfil: {},
    modulos: {},
    request: {},
  },
  mutations: {
    modulos (state,modulos = false) {
      state.modulos=modulos;
    },
    busqueda (state,busqueda = false) {
      state.busqueda=busqueda;
    },
    permisos (state,permisos = {}) {
      state.permisos=permisos;
    },
    usuario (state,usuario = {}) {
      state.usuario=usuario;
    },
    request (state,request = {}) {
      state.request=request;
    }
  }
})